import { AlkLogger } from '@alk/core';
import { COMMUNICATION_SERVICE, ICommunicationService } from '../../communication';
import { decodeFirmsAndInstrumentsResponse } from './firms-and-instruments-adapter.utils';
import { filter, finalize, map, shareReplay, takeUntil, tap } from 'rxjs/operators';
import { FirmsInstrumentsRequest, MessageTypes } from 'sfx-web-contract';
import { IFirmsAndInstrumentsAdapterService } from './firms-and-instruments-adapter.interface';
import { IFirmsAndInstrumentsMessageResponse } from '../../../interfaces';
import { inject, injectable } from 'inversify';
import { ISessionLifecycle, SESSION_LIFECYCLE_SERVICE } from '../../session-lifecycle';
import { Observable } from 'rxjs';

@injectable()
export class FirmsAndInstrumentsAdapterService implements IFirmsAndInstrumentsAdapterService {

    @inject(COMMUNICATION_SERVICE) private readonly communicationService: ICommunicationService;
    @inject(SESSION_LIFECYCLE_SERVICE) private readonly sessionLifeCycle: ISessionLifecycle;

    private rawFirmsInstrumentsFeed$: Observable<IFirmsAndInstrumentsMessageResponse>;

    asObservable(): Observable<IFirmsAndInstrumentsMessageResponse>{
        AlkLogger.info('[FirmsAndInstrumentsAdapterService#configurationObservable]');

        if (Boolean(this.rawFirmsInstrumentsFeed$)) {
            return this.rawFirmsInstrumentsFeed$;
        } else {
            const message = FirmsInstrumentsRequest.encode(
                FirmsInstrumentsRequest.create({}),
            ).finish();
            const requestId = this.communicationService.create(message, MessageTypes.FirmsInstruments);

            AlkLogger.debug(`[FirmsAndInstrumentsAdapterService#asObservable] subscription for ${ ''
            }clients list created with ${ requestId } token`);

            return this.rawFirmsInstrumentsFeed$ =
                this.communicationService.dataObservable(MessageTypes.FirmsInstruments)
                    .pipe(
                        takeUntil(this.sessionLifeCycle.destroyObservable()),
                        filter(response => response.communicationToken === requestId),
                        finalize(() => this.clear(requestId)),
                        map(decodeFirmsAndInstrumentsResponse),
                        tap(data => AlkLogger.debug([
                            '[FirmsAndInstrumentsAdapterService#asObservable] Received:',
                            JSON.stringify(data),
                        ].join(' '))),
                        shareReplay(1),
                    );
        }
    }

    private readonly clear = (token: number): void => {
        AlkLogger.debug('[FirmsAndInstrumentsAdapterService#clean] is about to dispose');
        this.communicationService.delete(token);
        this.rawFirmsInstrumentsFeed$ = null;
    };
}
